<template>
  <div id="app" class="parent container" :class="{ 'not-scroll': termsOpen }">
    <!-- Modal de terminos y condiciones, si no es acptado no se puede navegar en la web -->
    <modal
      name="terms"
      width="100%"
      height="auto"
      adaptive
      :clickToClose="false"
      :shiftY="1"
      @before-open="termsBeforeOpen"
      @before-close="termsBeforeClose"
    >
      <div class="terms-modal columns is-vcentered">
        <div class="logo column is-one-third">
          <p>ContaFácil</p>
        </div>
        <div class="options column">
          <label for="terms">
            <input
              type="checkbox"
              name="terms"
              v-model="termCookie"
              id="terms"
            />
            <div class="check-box-custom"></div>
            <p>
              Acepto los
              <a
                href="/files/T_C ContaFacil Usuarios Web. Tratamiento Necesario.pdf"
                download
                >Terminos y Condiciones y la Política de Privacidad</a
              >
            </p>
          </label>
          <label for="personaldata">
            <input
              type="checkbox"
              name="personaldata"
              v-model="dataCokkie"
              id="personaldata"
            />
            <div class="check-box-custom"></div>
            <p>
              Acepto el
              <a
                href="/files/Contafacil. T_C Usuarios Web. Tratamiento Opcional de datos personales.pdf"
                download
                >Tratamiento opcional de datos personales</a
              >
            </p>
          </label>
        </div>
        <div class="button-wrap column">
          <button
            class="button-terms-modal"
            :disabled="!termCookie"
            @click="aceptTerms"
          >
            Aceptar
          </button>
        </div>
      </div>
    </modal>
    <!-- Loader principal -->
    <modal name="loader-root" height="auto" adaptive @before-close="onClose">
      <img src="/images/loader.gif" alt="" />
    </modal>
    <!-- Modal que muestra un video -->
    <modal
      name="video-demo"
      adaptive
      height="auto"
      @before-open="videoBeforeOpen"
      @before-close="cleanVideo"
    >
      <div v-html="iframeSrc" v-if="iframeSrc"></div>
    </modal>
    <!-- Inicio de la Web en sí -->
    <nav-bar />
    <router-view class="main" />
    <the-footer />
    <a href="https://wa.me/+51914451872" id="whatsapp-btn" target="_blank">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="47.64"
        height="48"
        viewBox="0 0 256 258"
      >
        <defs>
          <linearGradient
            id="logosWhatsappIcon0"
            x1="50%"
            x2="50%"
            y1="100%"
            y2="0%"
          >
            <stop offset="0%" stop-color="#1FAF38" />
            <stop offset="100%" stop-color="#60D669" />
          </linearGradient>
          <linearGradient
            id="logosWhatsappIcon1"
            x1="50%"
            x2="50%"
            y1="100%"
            y2="0%"
          >
            <stop offset="0%" stop-color="#F9F9F9" />
            <stop offset="100%" stop-color="#FFF" />
          </linearGradient>
        </defs>
        <path
          fill="url(#logosWhatsappIcon0)"
          d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a122.994 122.994 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"
        />
        <path
          fill="url(#logosWhatsappIcon1)"
          d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"
        />
        <path
          fill="#FFF"
          d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561c0 15.67 11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716c-3.186-1.593-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"
        />
      </svg>
    </a>
  </div>
</template>

<script>
import NavBar from "./components/NavBar";
import TheFooter from "./components/TheFooter";
import { EventBus } from "./event-bus";
// import SideBar from "./components/SideBar";

const triggerGtagHandler = function(type) {
  this.$gtag.event(`${type}`, {
    event_category: "Button Click",
    event_label: "Button",
    value: "Clicked"
  });
};

EventBus.$on("triggerGtag", triggerGtagHandler);

export default {
  name: "ContafacilWeb",
  components: {
    NavBar,
    TheFooter
    // SideBar
  },
  data() {
    return {
      urlVideo: "",
      termsOpen: false,
      termCookie: false,
      dataCokkie: false,
      iframeSrc: null
    };
  },
  created() {
    // this.$modal.show("loader-root");
    // let cookies = document.cookie.split(";");
    // if (!cookies.some(cookie => cookie.includes("_terms=true"))) {
    //   console.log("no hay cookies");
    //   this.$modal.show("terms");
    // } else {
    //   console.log("hay cookies");
    //   this.termCookie = true;
    // }
  },
  mounted() {
    let cookies = document.cookie.split(";");
    if (!cookies.some(cookie => cookie.includes("_terms=true"))) {
      console.log("no hay cookies");
      this.$modal.show("terms");
    } else {
      console.log("hay cookies");
      this.termCookie = true;
    }
  },
  methods: {
    setUrlVideo() {},
    termsBeforeOpen() {
      console.log("beforeOpen");
      this.termsOpen = true;
    },
    termsBeforeClose() {
      this.termsOpen = false;
    },
    onClose() {
      let cookies = document.cookie.split(";");
      if (!cookies.some(cookie => cookie.includes("_terms=true"))) {
        this.$modal.show("terms");
      }
    },
    aceptTerms() {
      if (this.termCookie) {
        this.$modal.hide("terms");
      }
    },
    videoBeforeOpen(event) {
      this.iframeSrc = event.params.src;
    },
    cleanVideo() {
      this.iframeSrc = null;
    }
  },
  watch: {
    termCookie: function(n) {
      if (n) {
        document.cookie = "_terms=true";
      }
    },
    dataCokkie: function(n) {
      if (n) {
        document.cookie = "_data=true";
      }
    }
  }
};
</script>

<style lang="scss">
@import "./assets/styles/general.scss";
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");
#app {
  // font-family: Quicksand;
  font-family: "Quicksand", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  position: relative;
}
.vm--modal {
  background-color: transparent !important;
  box-shadow: none !important;
}
.vm--overlay {
  background: rgba(0, 0, 0, 0.4);
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.modal-content-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.terms-modal {
  background-color: $primary;
  padding: 2rem 0;
  .logo {
    p {
      color: #ffffff;
      font-weight: bold;
      font-size: 2rem;
    }
  }
  .options {
    label {
      margin: 1rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      .check-box-custom {
        width: 1.8rem;
        height: 1.8rem;
        border: 0.4rem solid #ffffff;
        margin-right: 1rem;
        position: relative;
      }
      input[type="checkbox"] {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: -1;
      }
      input[type="checkbox"]:checked ~ .check-box-custom {
        &::after {
          content: "\2713";
          font-size: 1.5rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #ffffff;
          font-weight: bold;
        }
      }
      p {
        color: #ffffff;
        font-size: 1rem;
        font-weight: 500;
        a {
          color: #ffffff;
          text-decoration: underline;
        }
        @include tablet() {
          font-size: 1.2rem;
        }
      }
    }
  }
  .button-wrap {
    .button-terms-modal {
      font-size: 1.2rem;
      font-weight: bold;
      background-color: $primary;
      border: thick solid #ffffff;
      border-radius: 5px;
      color: #ffffff;
      padding: 0.2em 1.8em;
      cursor: pointer;
      &:hover {
        background-color: #ffffff;
        border-color: $primary-dark;
        color: $primary-dark;
      }
      &:disabled {
        background-color: rgba($color: $primary, $alpha: 0.3);
        color: rgba($color: #cdcdcd, $alpha: 1);
        border-color: rgba($color: #cdcdcd, $alpha: 1);
        cursor: not-allowed;
      }
      @include tablet() {
        font-size: 1.5rem;
      }
    }
  }
}
.not-scroll {
  overflow: hidden;
}
#whatsapp-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #25d366; /* Color verde de WhatsApp */
  color: #fff;
  padding: 15px;
  border-radius: 50%;
  text-decoration: none;
  display: flex;
  align-items: center;
}

#whatsapp-btn i {
  margin-right: 8px;
}
</style>
